export default theme => {
  return {
    container: {
      border: `1px solid ${theme.palette.grey[400]}`,
      borderRadius: 4,
      overflow: 'scroll'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/adminView/AdminConfigManager/AdminDataMigrations.js